import { useState, useContext } from 'react';

import { AppContext } from 'commons-ui';
import { ContentPropsT } from './constants';
import { ticketInputs } from '../../constants';

const useContent = (props: ContentPropsT) => {
	const { onClose, handleForceUpdate, createTicket } = props;
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: ticketInputs) => {
		try {
			setShowLoader(true);
			const { topicId, subTopicId, transactionId, entryFee, description } = submittedData;
			await createTicket({ topicId, subTopicId, transactionId, entryFee, description });
			handleForceUpdate(true);
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in creating ticket', { type: 'error' });
		} finally {
			onClose();
		}
	};

	const handleFormCancel = () => {
		onClose();
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel
	};
};

export default useContent;
